// removed by extract-text-webpack-plugin
module.exports = {"text":"Time__text___2ot-i","time-info":"Time__time-info___3OW5B"};